var map = {
	"./gesture0.jpg": 779,
	"./gesture1.jpg": 646,
	"./gesture2.jpg": 705,
	"./lifedraw1.jpg": 539,
	"./lifedraw2.jpg": 908,
	"./lifedraw3.jpg": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 423;